import DownloadsTemplate from "./DownloadsTemplate";

export default function BoardMinutes() {
  const files = [
    {
      titleKey: "governance.boardMinutes.files.1.title",
      descKey: "governance.boardMinutes.files.1.desc",
      url: "#"
    },
    {
      titleKey: "governance.boardMinutes.files.2.title",
      descKey: "governance.boardMinutes.files.2.desc",
      url: "#"
    }
  ];

  return (
    <DownloadsTemplate
      titleKey="governance.boardMinutes.title"
      descriptionKey="governance.boardMinutes.description"
      files={files}
      seoTitleKey="governance.boardMinutes.seo.title"
      seoDescKey="governance.boardMinutes.seo.description"
      seoPath="/governance/board-minutes"
    />
  );
}